import { EditOutlined,PrinterOutlined } from "@ant-design/icons";
import { Space, Table, Drawer, Button, Col, Row, Tag } from 'antd';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';

import { Link } from 'react-router-dom';

import paymentService from "../../api/payment.service";
import commonUtility from "../../utility/Utils";
import { PRINT_BASE_URL } from "../../utility/URL";





const OtherItemsListView = ({ otherItemListValue, otherItemsMasterListValue, otherItemsDetailListValue, isDataUpdatedValue, module }) => {

  const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
  const [page, setPage] = React.useState(1);

  const [otherItemsList, setOtherItemsList] = useState([]);
  const [otherItemsMasterList, setOtherItemsMasterList] = useState([]);
  const [otherItemsDetailList, setOtherItemsDetailList] = useState([]);


  const detailColumn = [
    {
      title: 'Item',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Amount',
      dataIndex: 'net_amount',
      key: 'net_amount',
    }

  ]

  const pageSize = 10; 

  const pagination = {
    current: page, 
    pageSize: pageSize, 
  };

  const columns = [
    { 
      title: '#', 
      dataIndex: 'index', 
      render: (text, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
      width: '5%',
    },
    {
      title: 'Name',
      dataIndex: ['masterData', 'member_fname'],
      key: 'member_fname',


    },
    {
      title: 'Mobile No',
      dataIndex: ['masterData', 'primary_mobile'],
      key: 'primary_mobile',


    },
    {
      title: 'Receipt No',
      dataIndex: ['masterData', 'receipt_no'],
      key: 'receipt_no',



    },
    {
      title: 'Receipt Date',
      dataIndex: ['masterData', 'receipt_date'],
      key: 'receipt_date',
      render: (selectedObj, render) => (
        <>
          {commonUtility.formatStringDate(render.masterData.receipt_date)}
        </>


      )

    },



    {
      title: "Item Desc",
      dataIndex: "detailsData",
      render: (detailsData) => {
        //  return <Table columns={detailColumn} pagination={false} className="innerTable" dataSource={detailsData} />
        return detailsData.map((data) => {
          return (
            <div>
              <Row gutter={20} style={{ margin: "0.4rem" }}>
                <Col xs={16} xl={16} style={{ fontWeight: 'bold', borderRadius: 10, padding: 2, textIndent: 5 }} >{data.description}</Col>
                <Col xs={4} xl={4} ><Tag color="purple">{data.taxable_amount.toFixed(2)}</Tag></Col>
              </Row>
            </div>
          )
        })
      },
    },

    {
      title: 'Action',
      key: 'action',
      render: (selectedObj, render) => (
        <Space size="middle">
          {

            <>
              {
                module == "JCP" ? <>
                  <>
                    <Link to={render.masterData.entry_from == "A" ? `/enrollment-jcp/${render.masterData.enrollment_id}/${render.masterData.receipt_id}/${render.masterData.payment_id}` : `/jcp-monthly/${render.masterData.is_gst_bill == "Y" ? "gst" : "nongst"}/${render.masterData.enrollment_id}/${render.masterData.receipt_id}/${render.masterData.payment_id}`} >
                      <Button htmlType="button" type="ghost" size="small" shape="round"  >Edit <EditOutlined /></Button>
                    </Link>
                  </>


                  <a href={`${PRINT_BASE_URL}taxinvoice/receiptpdf/${render.masterData.enrollment_id}/${render.masterData.receipt_id}/${render.masterData.payment_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0 }`} target="_blank" rel="noopener noreferrer">
                      <Button htmlType="button" type="ghost" size="small" shape="round" type="primary" ><PrinterOutlined /> Print</Button>
                  </a>

                </> : <></>
              }

              {
                module == "PF" ? <>
                  <>
                    <Link to={render.masterData.entry_from == "A" ? `/enrollment-pf/${render.masterData.enrollment_id}/${render.masterData.receipt_id}/${render.masterData.payment_id}` : `/jcp-monthly/${render.masterData.is_gst_bill == "Y" ? "gst" : "nongst"}/${render.masterData.enrollment_id}/${render.masterData.receipt_id}/${render.masterData.payment_id}`} >
                      <Button htmlType="button" type="ghost" size="small" shape="round"  >Edit <EditOutlined /></Button>
                    </Link>
                  </>
                  <a href={`${PRINT_BASE_URL}taxinvoice/receiptpdf/${render.masterData.enrollment_id}/${render.masterData.receipt_id}/${render.masterData.payment_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0 }`} target="_blank" rel="noopener noreferrer">
                      <Button htmlType="button" type="ghost" size="small" shape="round" type="primary" ><PrinterOutlined /> Print</Button>
                  </a>
                </> : <></>
              }

              {
                module == "HP" ? <>
                  <>
                    <Link to={render.masterData.entry_from == "A" ? `/high-performance/${render.masterData.enrollment_id}/${render.masterData.receipt_id}/${render.masterData.payment_id}` : `/hp-monthly/${render.masterData.is_gst_bill == "Y" ? "gst" : "nongst"}/${render.masterData.enrollment_id}/${render.masterData.receipt_id}/${render.masterData.payment_id}`} >
                      <Button htmlType="button" type="ghost" size="small" shape="round">Edit <EditOutlined /></Button>
                    </Link>
                  </>
                  <a href={`${PRINT_BASE_URL}taxinvoice/receiptpdf/${render.masterData.enrollment_id}/${render.masterData.receipt_id}/${render.masterData.payment_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0 }`} target="_blank" rel="noopener noreferrer">
                      <Button htmlType="button" type="ghost" size="small" shape="round" type="primary" ><PrinterOutlined /> Print</Button>
                  </a>
                </> : <></>
              }

            </>
          }
        </Space>
      ),
    }
  ];





  useEffect(() => {
    setOtherItemsList(otherItemListValue)
    setOtherItemsMasterList(otherItemsMasterListValue)
    setOtherItemsDetailList(otherItemsDetailListValue)

  }, [isDataUpdatedValue])

  return (
    <>
      <Table
        columns={columns}
        //rowKey={receipt_id}
        rowKey={list => list.masterData.receipt_id}
        dataSource={otherItemListValue}
        size="small"
        pagination={{
          current: page,
          pageSize,
          onChange: (page) => setPage(page),
        }}
      />
    </>
  );
};

export default OtherItemsListView